import React, { useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAppDispatch } from '../../app/hooks';
import { resetOnboarding } from '../../features/tenants/tenantSlice';
import { OnboardingWizard } from '../../components/tenants/OnboardingWizard';

export const TenantOnboardingPage: React.FC = () => {
  const dispatch = useAppDispatch();

  // Reset onboarding state when component mounts
  useEffect(() => {
    dispatch(resetOnboarding());
  }, [dispatch]);

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center gap-4">
        <Link
          to="/tenants"
          className="flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to Tenants
        </Link>
      </div>

      <div>
        <h1 className="text-h1">Create New Tenant</h1>
        <p className="text-muted-foreground mt-1">
          Follow the steps below to onboard a new organization to the platform.
        </p>
      </div>

      {/* Onboarding Wizard */}
      <OnboardingWizard />
    </div>
  );
};

export default TenantOnboardingPage;
